import { gql } from 'src/__generated__';

export const DELETE_LICENCE = gql(`
  mutation ApplyDeleteLicence(
    $input: DeleteLicenceInput!
    $languageCode: LanguageCodeIso
    $zone: Zone
  ) {
    deleteLicence(input: $input) {
      viewer {
        _id
        licences(languageCode: $languageCode, zone: $zone) {
          ...licence
        }
      }
    }
  }

`);
